import { defineExperiment } from '@cian/experiments/ab';

import {
  AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC,
  AUD_WEB_BX1122_PIN_UNIFICATION,
  MARTECH_STONE_3SP_DESKTOP_EXPERIMENT,
} from '../constants/config/experiments';

/** Эксперимент спецпроекта Stone, активен только при фичатоггле Martech.Stone3SPDesktopExperiment.Enabled */
export const ExpStone3SPDesktop = defineExperiment(MARTECH_STONE_3SP_DESKTOP_EXPERIMENT, {
  groups: ['A', 'B'] as const,
  default: 'A',
});

export const ExpSinglePinLogic = defineExperiment(AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, {
  groups: ['A', 'B'] as const,
  default: 'A',
});

export const ExpPinsAndPopupRedesign = defineExperiment(AUD_WEB_BX1122_PIN_UNIFICATION, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
